import { render, staticRenderFns } from "./Presentism.vue?vue&type=template&id=17c3b07d"
import script from "./Presentism.vue?vue&type=script&lang=js"
export * from "./Presentism.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports